import React from 'react';
import PropTypes from 'prop-types';

import Placeholder from 'components/consumer/Placeholder';

const PDPProtectionPlanSelectorPlaceholder = ({ isLayoutRevamp = false }) =>
  isLayoutRevamp ? (
    // Add Protection row: 3rem plus its top and bottom border
    <div className="box-content w-full h-12 mt-8 border-0 border-y border-solid border-transparent">
      <Placeholder type="rect" loading className="!w-full !h-full !m-0" />
    </div>
  ) : (
    <div className="flex flex-col !w-full !h-[118px] mt-8 justify-between">
      <Placeholder type="text" loading row={1} className="!w-40 !h-6" />
      <Placeholder type="rect" loading className="!w-full !h-[73px]" />
    </div>
  );

PDPProtectionPlanSelectorPlaceholder.propTypes = {
  isLayoutRevamp: PropTypes.bool,
};

export default PDPProtectionPlanSelectorPlaceholder;
